import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TrendingDownIcon, AlertTriangleIcon, ThumbsUpIcon, ChevronRightIcon } from 'lucide-react';
interface InsightCard {
  title: string;
  value: string;
  type: 'neutral' | 'positive' | 'warning';
  icon: React.ElementType;
  targetId?: string;
}
interface AIResponseProps {
  message: string;
  insights?: InsightCard[];
  onInsightClick?: (id: string) => void;
}
export function AIResponse({
  message,
  insights,
  onInsightClick
}: AIResponseProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex gap-4 mb-8" data-id="element-36">
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-primary-indigo to-ai-purple flex items-center justify-center shadow-md" data-id="element-37">
        <SparklesIcon className="w-5 h-5 text-white" data-id="element-38" />
      </div>

      <div className="flex-1 space-y-4" data-id="element-39">
        <div className="bg-white rounded-2xl rounded-tl-none p-4 shadow-soft border border-slate-100" data-id="element-40">
          <p className="text-slate-700 text-[15px] leading-relaxed" data-id="element-41">
            {message}
          </p>
        </div>

        {insights && insights.length > 0 && <div className="grid grid-cols-2 gap-2.5" data-id="element-42">
            {insights.map((insight, idx) => {
          const Icon = insight.icon;
          const styles = {
            neutral: {
              chip: 'bg-slate-100 text-slate-500',
              value: 'text-dark-navy'
            },
            positive: {
              chip: 'bg-success/10 text-success',
              value: 'text-dark-navy'
            },
            warning: {
              chip: 'bg-warning/10 text-warning',
              value: 'text-dark-navy'
            }
          };
          const s = styles[insight.type];
          const clickable = Boolean(insight.targetId && onInsightClick);
          return <motion.button key={idx} type="button" disabled={!clickable} onClick={() => clickable && onInsightClick!(insight.targetId!)} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + idx * 0.08
          }} className={`relative p-3 rounded-2xl border border-slate-100 bg-white text-left flex flex-col gap-2 transition-all ${clickable ? 'cursor-pointer active:scale-[0.98] hover:border-slate-200' : 'cursor-default'}`} data-id="element-43">
                  <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${s.chip}`} data-id="element-44">
                    <Icon className="w-4 h-4" data-id="element-45" />
                  </div>
                  <div data-id="element-46">
                    <p className="text-[11px] font-medium text-slate-400 leading-tight mb-0.5" data-id="element-47">
                      {insight.title}
                    </p>
                    <p className={`font-display font-bold text-[15px] leading-snug ${s.value}`} data-id="element-48">
                      {insight.value}
                    </p>
                  </div>
                  {clickable && <ChevronRightIcon className="absolute top-3 right-3 w-4 h-4 text-slate-300" data-id="element-49" />}
                </motion.button>;
        })}
          </div>}
      </div>
    </motion.div>;
}